var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.128 55.216h3.816l.576-23.328 20.448 11.16 1.944-3.312L30.04 27.64l19.872-12.168-1.944-3.24L27.52 23.32 26.944.064h-3.816l-.576 23.256L2.104 12.232l-1.872 3.24 19.8 12.168-19.8 12.096 1.872 3.312 20.448-11.16.576 23.328z",
    fill: "currentColor"
  })));
}
export default SvgWild;